import { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  Image,
  Stack,
  Text
} from '@chakra-ui/react'
import { getNotificationMessage } from 'store'
import { ImagesPng } from 'assets/images'
import { QRCodeCanvas } from 'qrcode.react'
import { StyledButtonContainer } from 'common/Buttons/SingleButton/styled'
import { SUCCEEDED } from 'utils/constants'

export const WalletAddress = ({ walletAddress }) => {
  const dispatch = useDispatch()
  const [wallet, setWallet] = useState('Wallet')
  const [showWalletAddressQR, setShowWalletAddressQR] = useState(0)
  const [showLogo, setShowLogo] = useState(1)

  const handleWallet = () => {
    if (walletAddress) {
      const tempShowWalletAddress = !showWalletAddressQR

      if (tempShowWalletAddress) {
        setTimeout(() => {
          setShowWalletAddressQR(tempShowWalletAddress)
          setWallet('Close')
          setShowLogo(0)
          dispatch(
            getNotificationMessage({
              type: SUCCEEDED,
              message: 'Saved to Clipboard',
              isEditProfile: true
            })
          )
          navigator.clipboard.writeText(walletAddress)
        }, 100)

        setTimeout(() => {
          document.querySelector('#profile-wallet-btn')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }, 800)
      } else {
        setShowWalletAddressQR(tempShowWalletAddress)

        setTimeout(() => {
          setShowLogo(1)
          setWallet('Wallet')
        }, 800)
      }
    } else {
      setWallet('Wallet Address not yet connected')
      setShowLogo(0)

      setTimeout(() => {
        setWallet('Wallet')
        setShowLogo(1)
      }, 2000)
    }
  }

  return (
    <Stack
      position="relative"
      paddingTop={showWalletAddressQR ? '243px' : 0}
      transition="0.8s ease"
      display="flex"
      alignItems="center"
    >
      <Stack
        height={showWalletAddressQR ? '243px' : 0}
        margin="20px auto"
        width="auto"
        border={showWalletAddressQR ? 'solid 1px black' : ''}
        borderRadius="5px"
        padding={showWalletAddressQR ? '15px 10px 0px 10px' : 0}
        alignItems="center"
        transition="0.8s ease"
        overflow="hidden"
        position="absolute"
        top="-28px"
        left="auto"
        right="auto"
      >
        <QRCodeCanvas value={walletAddress} size={160} />
        <Text
          textAlign="center"
          maxWidth="240px"
        >
          {walletAddress}
        </Text>
      </Stack>

      <StyledButtonContainer
        id="profile-wallet-btn"
        name="profile-wallet"
        onClick={() => handleWallet()}
        style={{
          alignItems: 'center',
          width: '100%',
          minHeight: '38px',
          ...(!walletAddress && { backgroundColor: '#e6e6e6' })
        }}
      >
        {wallet}
        <Image
          boxSize="20px"
          margin={1}
          objectFit="cover"
          src={ImagesPng.LogoHeader}
          alt="Logo"
          borderRadius="full"
          display={showLogo ? 'flex' : 'none'}
        />
      </StyledButtonContainer>
    </Stack>
  )
}
